// src/pages/InvoiceForm.js
import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { 
    Button, 
    Form, 
    FormGroup, 
    Input, 
    Label, 
    Dropdown, 
    DropdownToggle, 
    DropdownMenu, 
    DropdownItem 
} from "reactstrap";
import { API_URL_invoice } from '../constants';

import { getAuthHeaders } from "../utils/auth";
const InvoiceForm = () => {
    const [invoiceDetails, setInvoiceDetails] = useState({
        amount: '',
        customerName: '',
        customerEmail: '',
        description: '',
        customerType: 'individual' // Default customer type
    });
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleChange = (e) => {
        setInvoiceDetails({ ...invoiceDetails, [e.target.name]: e.target.value });
    };

    const handleSelectCustomerType = (type) => {
        setInvoiceDetails({ ...invoiceDetails, customerType: type });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const headers = getAuthHeaders();

        // Log the invoice details before sending
        console.log("Invoice details being sent:", invoiceDetails);

        try {
            await axios.post(API_URL_invoice, invoiceDetails, { headers });
            toast.success('Invoice created successfully'); // Success toast
        } catch (error) {
            console.error('Error creating invoice:', error);
            toast.error('Error creating invoice. Please try again.'); // Error toast
        }
    };

    return (
        <div>
            <Form onSubmit={handleSubmit}>
                <FormGroup>
                    <Label for="amount">Amount</Label>
                    <Input 
                        type="number"
                        name="amount"
                        id="amount"
                        placeholder="Enter amount"
                        value={invoiceDetails.amount}
                        onChange={handleChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="customerName">Customer Name</Label>
                    <Input 
                        type="text"
                        name="customerName"
                        id="customerName"
                        placeholder="Enter customer name"
                        value={invoiceDetails.customerName}
                        onChange={handleChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="customerEmail">Customer Email</Label>
                    <Input 
                        type="email"
                        name="customerEmail"
                        id="customerEmail"
                        placeholder="Enter customer email"
                        value={invoiceDetails.customerEmail}
                        onChange={handleChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="description">Description</Label>
                    <Input 
                        type="textarea"
                        name="description"
                        id="description"
                        placeholder="Enter description"
                        value={invoiceDetails.description}
                        onChange={handleChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="customerType">Customer Type</Label>
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                        <DropdownToggle caret>
                            {invoiceDetails.customerType.charAt(0).toUpperCase() + invoiceDetails.customerType.slice(1)}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => handleSelectCustomerType('individual')}>
                                Individual
                            </DropdownItem>
                            <DropdownItem onClick={() => handleSelectCustomerType('business')}>
                                Business
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </FormGroup>
                <Button color="primary" type="submit">Create Invoice</Button>
            </Form>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </div>
    );
};

export default InvoiceForm;
